import { render, staticRenderFns } from "./specimens.vue?vue&type=template&id=4053a6f9&scoped=true&"
import script from "./specimens.vue?vue&type=script&lang=js&"
export * from "./specimens.vue?vue&type=script&lang=js&"
import style0 from "./specimens.vue?vue&type=style&index=0&lang=css&"
import style1 from "./specimens.vue?vue&type=style&index=1&id=4053a6f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4053a6f9",
  null
  
)

export default component.exports